import zxcvbn from "zxcvbn";

(function(){
    'use strict';
    angular.module('mso.registration').controller('RegisterCompleteCtrl', RegisterCompleteCtrl);

    RegisterCompleteCtrl.$inject = ['$scope', 'referenceData', 'RegisterCompleteService', '$location', '$exceptionHandler'];
    function RegisterCompleteCtrl($scope, referenceData, RegisterCompleteService, $location, $exceptionHandler){
        var vm = this;

        // Initialise vm variables
        vm.messages = referenceData.messages;
        vm.parameters = referenceData.parameters;
        vm.referenceData = referenceData;
        vm.showResponseMessage = false;
        vm.showValidation = false;
        vm.tokenId = $location.path().substring(1).split('/')[1];
        vm.vs = referenceData.valuesets;
        $scope.showValidationToaster = false;
        vm.passwordStrengthPercentage = 0;
        vm.regexPass = false;
        vm.securityAnswerLength = ['2', '200', 'characters'];

        // Which password validation should be used
        vm.passwordTestingParam = vm.parameters.p6554;

        //Initialise vm functions
        vm.submitForm = submitForm;
        vm.completeRegistration = completeRegistration;
        vm.completeImportRegistration = completeImportRegistration;
        vm.validatePasswordStrength = validatePasswordStrength;
        vm.validatePasswordSameAsUserName = validatePasswordSameAsUserName;
        vm.passwordReset = passwordReset;
        vm.validatePasswordMatch = validatePasswordMatch;

        // Email address validation parameters. P6259 - pValidMSOEmailFormat, P6260 - pMinEmailAddressLength, P6261 - pMaxEmailAddressLength.
        vm.emailAddressRegEx = new RegExp(vm.parameters.p6259);
        vm.emailMinCharacterLength = vm.parameters.p6260;
        vm.emailMaxCharacterLength = vm.parameters.p6261;

        vm.usernameRegEx = new RegExp(vm.parameters.p6145);

        //by default we assume this is completion of a normal registration via the intermediary website, and security questions have already been captured
        vm.hasSecurityQuestions = true;

        vm.securityQuestion1 = {'securityQuestion': undefined, 'securityAnswer': ''};
        vm.securityQuestion2 = {'securityQuestion': undefined, 'securityAnswer': ''};
        vm.securityQuestion3 = {'securityQuestion': undefined, 'securityAnswer': ''};
        vm.securityQuestions = [vm.securityQuestion1, vm.securityQuestion2, vm.securityQuestion3];
        vm.chosenSecurityQuestions = [];

        activate();

        function activate()
        {
            getQuestionText();
            getPasswordBlackList();
        }
        function submitForm(form){
            if (vm.hasSecurityQuestions){
                completeRegistration(form);
            } else {
                completeImportRegistration(form);
            }

        }


        function completeRegistration(form){
            vm.showResponseMessage = false;
            if(form.$invalid){
                vm.showValidation = true;
                $scope.showValidationToaster = true;
                return;
            }
            var registrationDetails = RegisterCompleteService.prepareRegistrationDetails(vm);
            RegisterCompleteService.completeRegistration(registrationDetails).then(function(data){
                $location.path('/register-complete-success');
            },function(error){
                if(error.status == '400') {
                    if (error.data.message === 'User name already exists. Please choose another') {
                        form.userName.$setValidity('duplicate', false);
                        vm.showValidation = true;
                        $scope.showValidationToaster = true;
                    } else {
                        vm.responseMessage = error.data.message;
                        vm.showResponseMessage = true;
                    }
                }
                else{
                    $exceptionHandler(error);
                }
            });
        }

        function completeImportRegistration(form){
            vm.showResponseMessage = false;
            if(form.$invalid){
                vm.showValidation = true;
                $scope.showValidationToaster = true;
                return;
            }
            var registrationDetails = RegisterCompleteService.prepareRegistrationDetails(vm);
            RegisterCompleteService.completeRegistration(registrationDetails).then(function(data){
                $location.path('/register-complete-success');
            },function(error){
                if(error.status === 401) {
                    //expired and used tokens
                    $location.path('/register-complete-expired');
                }
                else if(error.status === 403) {
                    //user has been deactivated
                    $location.path('/register-complete-deactivated');
                }
                else if(error.status === 404) {
                    vm.responseMessage = error.data.message;
                    vm.showResponseMessage = true;
                }
                else{
                    $exceptionHandler(error);
                }
            });
        }

        function getQuestionText() {
            RegisterCompleteService.getSecurityQuestion(vm.tokenId).then(function(data){
                vm.securityQuestionId = data.securityQuestionId;
                vm.questionText = data.securityQuestionText;
                vm.title = 'Set your user name and password';
            }, function(error){
                if(error.status === 401) {
                    //expired and used tokens
                    $location.path('/register-complete-expired');
                }
                else if(error.status === 403) {
                    //user has been deactivated
                    $location.path('/register-complete-deactivated');
                }
                else if(error.status === 404) {
                    vm.hasSecurityQuestions = false;
                    vm.title = 'Set your security questions and password';
                    $scope.$watch('vm.securityQuestion1', handleChosenSecurityChange, true);
                    $scope.$watch('vm.securityQuestion2', handleChosenSecurityChange, true);
                    $scope.$watch('vm.securityQuestion3', handleChosenSecurityChange, true);
                }
                else {
                    $exceptionHandler(error);
                }
            });
        }
        
        function getPasswordBlackList()
        {
            RegisterCompleteService.getPasswordBlackList().then(function(data){
                vm.passwordBlackList = data;
            }, function(error){
                $exceptionHandler(error);
            })
        }

        function validatePasswordStrength(password){
            var passwordValid = true;

            switch(vm.passwordTestingParam)
            {
                case '1':
                    passwordValid = traditionalPasswordStrength(password);
                    break;
                case '2': 
                    passwordValid = modernPasswordStrength(password);
                    break;
                case '3':
                    passwordValid = combinedStrengthCheck(password);
                    break;
                default:
                    passwordValid = traditionalPasswordStrength(password);
            }
            return passwordValid;
        }

        function combinedStrengthCheck(password)
        {
            // Running these individually and then evaluating together, to ensure any updates to UI
            // e.g. strength bar, are always updated
            var modernPass = modernPasswordStrength(password);
            var traditionalPass = traditionalPasswordStrength(password);
            return modernPass && traditionalPass;
        }

        function traditionalPasswordStrength(password)
        {
            if(angular.isUndefined(password) || password.length < 8){
                vm.regexPass = false;
                return false;
            }
            //Perform positive look ups to see if we have at least one of the following:
            //Lower case, Upper case, Number
            var regex = RegExp(vm.parameters.p6142);
            if(!regex.test(password)){
                vm.regexPass = false;
                return false;
            }

            vm.regexPass = true;
            return true;
        }

        // Uses Dropboxes zxcvbn plugin
        function modernPasswordStrength(password)
        {
            if(angular.isDefined(password) && password !== '')
            {
                var contextUnacceptablePasswords = [];
                contextUnacceptablePasswords.push(vm.emailAddress, vm.securityAnswer, vm.userName);
                angular.forEach(vm.securityQuestions, function(question){
                    contextUnacceptablePasswords.push(question.securityAnswer)
                });
                angular.forEach(contextUnacceptablePasswords, function(item){
                    if(angular.isDefined(item)) 
                    {
                        vm.passwordBlackList.push(item);
                    }
                })
                vm.zxcvbnResult = zxcvbn(password, vm.passwordBlackList);
                vm.passwordMatchPatterns = [];
                angular.forEach(vm.zxcvbnResult.sequence, function(match){
                    vm.passwordMatchPatterns.push(match.pattern)
                })
                vm.passwordStrength = vm.zxcvbnResult.score;
            }
            else
            {
                vm.passwordStrength = 0;
                vm.passwordStrengthPercentage = 0;
            }

            vm.passwordStrengthPercentage = vm.passwordStrength > 0 ? (vm.passwordStrength + 1) * 20 : 0;
            
            if(vm.passwordStrength < 3)
            {
                return false;
            }

            return true;
        }

        function validatePasswordSameAsUserName(password){
            if (password && password.length > 0 && vm.userName && vm.userName.length > 0) {
                if (password.toUpperCase() === vm.userName.toUpperCase())
                {
                    return false;
                }
            }

            return true;
        }


        function passwordReset(form){

            form.password.$setValidity('strength', true);
            form.password.$setValidity('sameAsUserName', true);
        }

        function validatePasswordMatch(password){
            return (vm.password === password);
        }

        function handleChosenSecurityChange(newValue, oldValue) {
            // Update vm.chosenSecurityQuestions
            if (angular.isDefined(oldValue) && angular.isDefined(oldValue.securityQuestion)) {
                var index = vm.chosenSecurityQuestions.indexOf(oldValue.securityQuestion);
                if (index !== -1) {
                    // Old value found in chosen questions. Remove it.
                    vm.chosenSecurityQuestions.splice(index, 1);
                }
                if (angular.isDefined(newValue) && angular.isDefined(newValue.securityQuestion)) {
                    // Add the new choice to the chosen questions
                    vm.chosenSecurityQuestions.push(newValue.securityQuestion);
                }
            }
            else if (angular.isDefined(newValue) && angular.isDefined(newValue.securityQuestion)) {
                // Add the new choice to the chosen questions
                vm.chosenSecurityQuestions.push(newValue.securityQuestion);
            }

            // Figure out whether security answers are unique
            syncSecurityAnswers();
        }

        function syncSecurityAnswers() {
            // Reset validity before scanning each question/answer set
            $scope.completeRegistration.securityQuestionFormMain.$setValidity('answerIsNotUnique', true);

            checkSecurityAnswerForUniqueness(vm.securityQuestion1);
            checkSecurityAnswerForUniqueness(vm.securityQuestion2);
            checkSecurityAnswerForUniqueness(vm.securityQuestion3);
        }

        function checkSecurityAnswerForUniqueness(securityQuestion) {
            securityQuestion.isSecurityAnswerUnique = isSecurityAnswerUnique(securityQuestion.securityAnswer);
            if (!securityQuestion.isSecurityAnswerUnique) {
                // Answer is not unique. Invalidate the main form so that it won't submit.
                $scope.completeRegistration.securityQuestionFormMain.$setValidity('answerIsNotUnique', false);
            }
        }

        function isSecurityAnswerUnique(securityAnswer) {
            // Treat empty values as unique
            if (!angular.isDefined(securityAnswer) || securityAnswer === "") {
                return true;
            }

            var matchingAnswers = vm.securityQuestions.filter(function (item) {
                return item.securityAnswer === securityAnswer;
            });

            // If the answer is unique it should be the only instance in the collection.
            return matchingAnswers.length === 1;
        }

    }
})();